<template>
  <div class="map-container">
    <div v-show="titleVisible && !areaOnly" class="map-titles">
      <div class="map-title">Nederland verdient meer wilde natuur</div>
      <div class="map-slogan">ARK Rewilding Nederland werkt al 35 jaar met partners aan wildere  natuur. Klik door de kaart om te zien wat we doen en ontdek meer over rewilding.</div>
      <div class="map-start">
        <div @click="titleVisible=false" class="map-start-button">Start</div>

      </div>
    </div>



    <div class="map-wrapper">
      <div class="map-controls">
        <svg v-if="!areaOnly" @click="toggleFilters" width="41" height="40" viewBox="0 0 41 40" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M20.5 -8.74228e-07C31.5457 -1.35705e-06 40.5 8.9543 40.5 20C40.5 31.0457 31.5457 40 20.5 40C9.45431 40 0.5 31.0457 0.499999 20C0.499999 8.9543 9.4543 -3.91405e-07 20.5 -8.74228e-07Z" fill="#0A5256"/>
          <path fill-rule="evenodd" clip-rule="evenodd" d="M39.1667 20C39.1667 9.69068 30.8093 1.33333 20.5 1.33333C10.1907 1.33333 1.83333 9.69068 1.83333 20C1.83333 30.3093 10.1907 38.6667 20.5 38.6667C30.8093 38.6667 39.1667 30.3093 39.1667 20ZM40.5 20C40.5 8.9543 31.5457 -1.35705e-06 20.5 -8.74228e-07C9.4543 -3.91405e-07 0.499999 8.9543 0.499999 20C0.5 31.0457 9.45431 40 20.5 40C31.5457 40 40.5 31.0457 40.5 20Z" fill="#0A5256"/>
          <path fill-rule="evenodd" clip-rule="evenodd" d="M15.8333 6C16.2015 6 16.5 6.29848 16.5 6.66667L16.5 33.3333C16.5 33.7015 16.2015 34 15.8333 34C15.4651 34 15.1666 33.7015 15.1666 33.3333L15.1666 6.66667C15.1666 6.29848 15.4651 6 15.8333 6Z" fill="white"/>
          <path d="M15.8333 10.6667C18.4106 10.6667 20.5 12.756 20.5 15.3333C20.5 17.9107 18.4106 20 15.8333 20C13.256 20 11.1666 17.9107 11.1666 15.3333C11.1666 12.756 13.256 10.6667 15.8333 10.6667Z" fill="#0A5256"/>
          <path fill-rule="evenodd" clip-rule="evenodd" d="M19.1666 15.3333C19.1666 13.4924 17.6742 12 15.8333 12C13.9923 12 12.5 13.4924 12.5 15.3333C12.5 17.1743 13.9923 18.6667 15.8333 18.6667C17.6742 18.6667 19.1666 17.1743 19.1666 15.3333ZM20.5 15.3333C20.5 12.756 18.4106 10.6667 15.8333 10.6667C13.256 10.6667 11.1666 12.756 11.1666 15.3333C11.1666 17.9107 13.256 20 15.8333 20C18.4106 20 20.5 17.9107 20.5 15.3333Z" fill="white"/>
          <path fill-rule="evenodd" clip-rule="evenodd" d="M25.1667 34C24.7985 34 24.5 33.7015 24.5 33.3333L24.5 6.66667C24.5 6.29848 24.7985 6 25.1667 6C25.5349 6 25.8334 6.29848 25.8334 6.66667L25.8334 33.3333C25.8334 33.7015 25.5349 34 25.1667 34Z" fill="white"/>
          <path d="M25.1667 29.3333C22.5894 29.3333 20.5 27.244 20.5 24.6667C20.5 22.0893 22.5894 20 25.1667 20C27.744 20 29.8334 22.0893 29.8334 24.6667C29.8334 27.244 27.744 29.3333 25.1667 29.3333Z" fill="#0A5256"/>
          <path fill-rule="evenodd" clip-rule="evenodd" d="M21.8334 24.6667C21.8334 26.5076 23.3258 28 25.1667 28C27.0077 28 28.5 26.5076 28.5 24.6667C28.5 22.8257 27.0077 21.3333 25.1667 21.3333C23.3258 21.3333 21.8334 22.8257 21.8334 24.6667ZM20.5 24.6667C20.5 27.244 22.5894 29.3333 25.1667 29.3333C27.744 29.3333 29.8334 27.244 29.8334 24.6667C29.8334 22.0893 27.744 20 25.1667 20C22.5894 20 20.5 22.0893 20.5 24.6667Z" fill="white"/>
        </svg>
        <svg @click="zoomIn" width="41" height="40" viewBox="0 0 41 40" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M20.5 -8.74228e-07C31.5457 -1.35705e-06 40.5 8.9543 40.5 20C40.5 31.0457 31.5457 40 20.5 40C9.45431 40 0.5 31.0457 0.499999 20C0.499999 8.9543 9.4543 -3.91405e-07 20.5 -8.74228e-07Z" fill="white"/>
          <path fill-rule="evenodd" clip-rule="evenodd" d="M39.1667 20C39.1667 9.69068 30.8093 1.33333 20.5 1.33333C10.1907 1.33333 1.83333 9.69068 1.83333 20C1.83333 30.3093 10.1907 38.6667 20.5 38.6667C30.8093 38.6667 39.1667 30.3093 39.1667 20ZM40.5 20C40.5 8.9543 31.5457 -1.35705e-06 20.5 -8.74228e-07C9.4543 -3.91405e-07 0.499999 8.9543 0.499999 20C0.5 31.0457 9.45431 40 20.5 40C31.5457 40 40.5 31.0457 40.5 20Z" fill="#0A5256"/>
          <path fill-rule="evenodd" clip-rule="evenodd" d="M20.5 10.6665C20.8681 10.6665 21.1666 10.965 21.1666 11.3332L21.1666 28.6665C21.1666 29.0347 20.8681 29.3332 20.5 29.3332C20.1318 29.3332 19.8333 29.0347 19.8333 28.6665L19.8333 11.3332C19.8333 10.965 20.1318 10.6665 20.5 10.6665Z" fill="black"/>
          <path fill-rule="evenodd" clip-rule="evenodd" d="M29.8334 19.9998C29.8334 20.368 29.5349 20.6665 29.1667 20.6665L11.8334 20.6665C11.4652 20.6665 11.1667 20.368 11.1667 19.9998C11.1667 19.6316 11.4652 19.3332 11.8334 19.3332L29.1667 19.3332C29.5349 19.3332 29.8334 19.6316 29.8334 19.9998Z" fill="black"/>
        </svg>
        <svg  @click="zoomOut"  width="41" height="40" viewBox="0 0 41 40" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M40.5 20C40.5 31.0457 31.5457 40 20.5 40C9.45431 40 0.5 31.0457 0.5 20C0.5 8.95431 9.45431 0 20.5 0C31.5457 0 40.5 8.95431 40.5 20Z" fill="white"/>
          <path fill-rule="evenodd" clip-rule="evenodd" d="M20.5 38.6667C30.8093 38.6667 39.1667 30.3093 39.1667 20C39.1667 9.69069 30.8093 1.33333 20.5 1.33333C10.1907 1.33333 1.83333 9.69069 1.83333 20C1.83333 30.3093 10.1907 38.6667 20.5 38.6667ZM20.5 40C31.5457 40 40.5 31.0457 40.5 20C40.5 8.95431 31.5457 0 20.5 0C9.45431 0 0.5 8.95431 0.5 20C0.5 31.0457 9.45431 40 20.5 40Z" fill="#0A5256"/>
          <path fill-rule="evenodd" clip-rule="evenodd" d="M29.8334 19.9998C29.8334 20.368 29.5349 20.6665 29.1667 20.6665L11.8334 20.6665C11.4652 20.6665 11.1667 20.368 11.1667 19.9998C11.1667 19.6316 11.4652 19.3332 11.8334 19.3332L29.1667 19.3332C29.5349 19.3332 29.8334 19.6316 29.8334 19.9998Z" fill="#0A5256"/>
          <path fill-rule="evenodd" clip-rule="evenodd" d="M29.8334 19.9998C29.8334 20.368 29.5349 20.6665 29.1667 20.6665L11.8334 20.6665C11.4652 20.6665 11.1667 20.368 11.1667 19.9998C11.1667 19.6316 11.4652 19.3332 11.8334 19.3332L29.1667 19.3332C29.5349 19.3332 29.8334 19.6316 29.8334 19.9998Z" fill="#0A5256"/>
        </svg>
        <svg v-if="!areaOnly" @click="toggleInfo" width="41" height="40" viewBox="0 0 41 40" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M40.5 20C40.5 31.0457 31.5457 40 20.5 40C9.45431 40 0.5 31.0457 0.5 20C0.5 8.95431 9.45431 0 20.5 0C31.5457 0 40.5 8.95431 40.5 20Z" fill="white"/>
          <path fill-rule="evenodd" clip-rule="evenodd" d="M20.5 38.6667C30.8093 38.6667 39.1667 30.3093 39.1667 20C39.1667 9.69069 30.8093 1.33333 20.5 1.33333C10.1907 1.33333 1.83333 9.69069 1.83333 20C1.83333 30.3093 10.1907 38.6667 20.5 38.6667ZM20.5 40C31.5457 40 40.5 31.0457 40.5 20C40.5 8.95431 31.5457 0 20.5 0C9.45431 0 0.5 8.95431 0.5 20C0.5 31.0457 9.45431 40 20.5 40Z" fill="#0A5256"/>
          <path fill-rule="evenodd" clip-rule="evenodd" d="M20.5 16.75C22.341 16.75 23.8334 15.2576 23.8334 13.4167C23.8334 11.5757 22.341 10.0833 20.5 10.0833C18.6591 10.0833 17.1667 11.5757 17.1667 13.4167C17.1667 15.2576 18.6591 16.75 20.5 16.75ZM20.5 18.0833C23.0774 18.0833 25.1667 15.994 25.1667 13.4167C25.1667 10.8393 23.0774 8.75 20.5 8.75C17.9227 8.75 15.8334 10.8393 15.8334 13.4167C15.8334 15.994 17.9227 18.0833 20.5 18.0833Z" fill="#0A5256"/>
          <path fill-rule="evenodd" clip-rule="evenodd" d="M20.5 31.25C20.1319 31.25 19.8334 31.0768 19.8334 30.8631L19.8334 20.8037C19.8334 20.59 20.1319 20.4167 20.5 20.4167C20.8682 20.4167 21.1667 20.59 21.1667 20.8037L21.1667 30.8631C21.1667 31.0768 20.8682 31.25 20.5 31.25Z" fill="#0A5256"/>
        </svg>
        <svg @click="reset" width="41" height="40" viewBox="0 0 41 40" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M40.5 20C40.5 31.0457 31.5457 40 20.5 40C9.45431 40 0.5 31.0457 0.5 20C0.5 8.95431 9.45431 0 20.5 0C31.5457 0 40.5 8.95431 40.5 20Z" fill="white"/>
          <path fill-rule="evenodd" clip-rule="evenodd" d="M13.5718 16.4568C13.9391 16.4568 14.2368 16.7545 14.2368 17.1218L14.2368 27.1218C14.2368 27.4891 13.9391 27.7868 13.5718 27.7868C13.2045 27.7868 12.9068 27.4891 12.9068 27.1218L12.9068 17.1218C12.9068 16.7545 13.2045 16.4568 13.5718 16.4568Z" fill="#0A5256"/>
          <path fill-rule="evenodd" clip-rule="evenodd" d="M22.2368 27.1219C22.2368 27.4891 21.9391 27.7869 21.5718 27.7869L13.5718 27.7869C13.2045 27.7869 12.9068 27.4891 12.9068 27.1219C12.9068 26.7546 13.2045 26.4569 13.5718 26.4569L21.5718 26.4569C21.9391 26.4569 22.2368 26.7546 22.2368 27.1219Z" fill="#0A5256"/>
          <path fill-rule="evenodd" clip-rule="evenodd" d="M12.9958 17.4543C12.8122 17.1363 12.9212 16.7296 13.2392 16.5459L20.1674 12.5459C20.4855 12.3623 20.8922 12.4713 21.0758 12.7893C21.2595 13.1074 21.1505 13.5141 20.8324 13.6977L13.9042 17.6977C13.5862 17.8814 13.1795 17.7724 12.9958 17.4543Z" fill="#0A5256"/>
          <path fill-rule="evenodd" clip-rule="evenodd" d="M19.9241 12.7893C20.1077 12.4712 20.5144 12.3622 20.8325 12.5459L27.7607 16.5459C28.0788 16.7295 28.1877 17.1362 28.0041 17.4543C27.8205 17.7724 27.4138 17.8813 27.0957 17.6977L20.1675 13.6977C19.8494 13.5141 19.7405 13.1074 19.9241 12.7893Z" fill="#0A5256"/>
          <path fill-rule="evenodd" clip-rule="evenodd" d="M27.4283 16.4568C27.7955 16.4568 28.0933 16.7545 28.0933 17.1218L28.0933 27.1218C28.0933 27.4891 27.7955 27.7868 27.4283 27.7868C27.061 27.7868 26.7633 27.4891 26.7633 27.1218L26.7633 17.1218C26.7633 16.7545 27.061 16.4568 27.4283 16.4568Z" fill="#0A5256"/>
          <path fill-rule="evenodd" clip-rule="evenodd" d="M20.5 38.6667C30.8093 38.6667 39.1667 30.3093 39.1667 20C39.1667 9.69069 30.8093 1.33333 20.5 1.33333C10.1907 1.33333 1.83333 9.69069 1.83333 20C1.83333 30.3093 10.1907 38.6667 20.5 38.6667ZM20.5 40C31.5457 40 40.5 31.0457 40.5 20C40.5 8.95431 31.5457 0 20.5 0C9.45431 0 0.5 8.95431 0.5 20C0.5 31.0457 9.45431 40 20.5 40Z" fill="#0A5256"/>
        </svg>
      </div>

      <div id="ark_35_map"></div>

      <FiltersComponent ref="filters"  v-if="showFilters" :filters="filters" @toggle-filter="toggleFilter" :active="showActive" @set-active="toggleActive"  @show-tag="showTag" @close="toggleFilters"/>



      <SidebarComponent v-if="showInfo" @close="closeInfo" >
        <template #title>Hoe werkt deze kaart?</template>
        <div class="info-content">
          <p>Op deze kaart vind je alle plekken waar ARK Rewilding Nederland aan wildere natuur werkt, of heeft gewerkt. Rewilding betekent dat natuur vrij is om zichzelf vorm te geven door natuurlijke processen zoals het stromen van water, de invloeden van dieren en planten en de kringloop van leven en dood. Regelmatig zijn die natuurlijke processen stilgelegd, en zet ARK ze met een klein zetje weer in gang. Hoe én waarom we dat doen, ontdek je via deze kaart.</p>
          <p>Klik op een pin op de kaart. In het informatieveld lees je meer over het gebied en eventueel over het rewildingprogramma waarvan dat gebied onderdeel is. Klik op de i’s om meer te leren over de aandachtsgebieden van het rewildingswerk van ARK, en om te ontdekken hoe wilde natuur onze samenleving helpt.</p>
        </div>
      </SidebarComponent>

      <SidebarComponent v-if="selected_marker" :double="double">
        <template #title><span v-html="selected_marker.title" ></span></template>
        <SelectedFeatureComponent   :area-only="areaOnly" :tags="tags" :filters="filters" :selected_marker="selected_marker" @show-tag="showTag" @show-area="showArea" @show-program="showProgram">
        </SelectedFeatureComponent>

      </SidebarComponent>

      <SidebarComponent v-if="selected_area" :double="double" @close="closeArea">
        <template #title>gebied</template>
        <SelectedAreaComponent  :selected_area="selected_area" @show-program="showProgram">
        </SelectedAreaComponent>

      </SidebarComponent>

      <SidebarComponent v-if="selected_program" :double="double"  @close="closeProgram">
        <template #title>gebiedsprogramma</template>
        <SelectedProgramComponent  :selected_program="selected_program" >
        </SelectedProgramComponent>

      </SidebarComponent>

      <SidebarComponent v-if="selected_tag" :double="true" @close="selected_tag = null" >
        <template #title>{{ tagLabel }}</template>
        <SelectedTagComponent   :selected_tag="selected_tag" >
        </SelectedTagComponent>

      </SidebarComponent>


    </div>


    </div>

</template>

<script>

import mapboxgl from 'mapbox-gl';
import 'mapbox-gl/dist/mapbox-gl.css';
import 'mapbox-gl-style-switcher/styles.css';
import axios from 'axios';
import '@mapbox/mapbox-gl-geocoder/dist/mapbox-gl-geocoder.css';
import SidebarComponent from './SidebarComponent.vue';
import SelectedFeatureComponent from './SelectedFeatureComponent.vue';
import FiltersComponent from './FiltersComponent.vue';
import SelectedTagComponent from './SelectedTagComponent.vue';
import InfoControl from '../InfoControl';
import SelectedAreaComponent from './SelectedAreaComponent.vue';
import SelectedProgramComponent from './SelectedProgramComponent.vue';
import bbox from '@turf/bbox';
import MapboxGeocoder from '@mapbox/mapbox-gl-geocoder';

mapboxgl.accessToken = 'pk.eyJ1IjoiYXJrcmV3aWxkaW5nIiwiYSI6ImNtNGxkdWxwcTAwcXoybXNjY3p3OG8wbHoifQ.h8S_cat3a24vCDH1Tm9W-g';










export default {
  name: "MapComponent",
  props: {
    'translations': {
      required: false
    },
    'node_id': {
      required: false
    }
  },
  data: function () {
    return {
      bounds: {
        "type": "FeatureCollection",
        "features": [
          {
            "type": "Feature",
            "properties": {},
            "geometry": {
              "coordinates": [
                [
                  [
                    7.115861507159565,
                    54.514002168167536
                  ],
                  [
                    1.125544843755705,
                    54.5005221632986
                  ],
                  [
                    1.2264122927690835,
                    50.690118833118646
                  ],
                  [
                    7.114634231755048,
                    50.68157021706202
                  ],
                  [
                    7.115861507159565,
                    54.514002168167536
                  ]
                ]
              ],
              "type": "Polygon"
            }
          }
        ]
      },
      titleVisible: true,
      map: undefined,
      tags: [],
      parent_tags: [],
      selected_marker: null,
      selected_area: null,
      selected_program: null,
      selected_tag: null,
      showInfo: false,
      showFilters: false,
      showSidebar: false,
      geojson: null,
      features: [],
      image : null,
      showActive: false,
      markersOnScreen: {},
      markers: {},
      filters: [
        {
          name:"Ruimte maken voor water",
          tid: 2211,
          checked: true,
          color: "#3A6742",
          offset_color: "#48614A"
        },
        {
          name:"Landschappen herstellen",
          tid: 2219,
          checked: true,
          color: "#6B994D",
          offset_color: "#6E895B"
        },
        {
          name:"Kringlopen herstellen",
          tid: 2220,
          checked: true,
          color: "#A8C956",
          offset_color: "#93A866"
        },
        {
          name:"Natuur verbinden",
          tid: 2226,
          checked: true,
          color: "#F1E8CF",
          offset_color: "#BFBBAE"
        },
        {
          name:"Ruimte maken voor wilde dieren",
          tid: 2229,
          checked: true,
          color: "#CE7C8C",
          offset_color: "#AB7983"
        },
        {
          name:"Natuurbeleving mogelijk maken",
          tid: 2249,
          checked: true,
          color: "#B8235C",
          offset_color: "#9C4B60"
        },

      ]

    }
  },
  components: {
    SelectedProgramComponent,
    SelectedAreaComponent,
    SidebarComponent,
    SelectedFeatureComponent,
    FiltersComponent,
    SelectedTagComponent
  },
  watch: {
    filters: {
      handler: function () {
        this.filterFeatures();
      },
      deep: true
    },
    showActive: {
      handler: function () {
        this.filterFeatures();
      },
      deep: true
    },
    titleVisible: {
      handler: function (value) {

        if(this.map.getLayer('no_uk_layer')) {
        if(value) {
          this.map.setLayoutProperty('no_uk_layer', 'visibility', 'visible');
        } else {
          this.map.setLayoutProperty('no_uk_layer', 'visibility', 'none');
        }
        }
      },
    }

  },
  computed: {
    hasArea() {
      return this.selected_marker && (this.selected_marker.program != '' || this.selected_marker.area != '');
    },
    areaOnly() {
      return this.node_id != null;
    },
    double() {
      return this.hasArea;
      // return this.hasArea && !this.areaOnly;
    },
    tagLabel() {
      return this.selected_tag.vid == 'wat_doet_ark' ? 'Wat doet ARK?' : 'Dit draagt bij aan';
    },
  },
  methods: {
    filterFeatures() {

      let filters = this.filters.filter(filter => filter.checked).map(filter => filter.tid);

      if(filters.length === 0) {

        this.map.getSource('markers').setData({
          type: 'FeatureCollection',
          features: []
        });



      } else {



        let features  = this.geojson.features.filter(feature => {
          if(this.showActive && feature.properties.active == '0') {
            return false;
          }



          let terms = feature.properties.what.split(',').map(tid => parseInt(tid.trim()));

          let parents  = [];

          terms.forEach(term => {
            let tag = this.tags.find(tag => parseInt(tag.tid) === term);
            if (tag) {
              let parent = tag.parent_target_id;
              if (parent) {
                parents.push(parseInt(parent));
              }
            }
          });

          //check if item in both parents and filters

          if (parents.length > 0) {
            return parents.some(parent => filters.includes(parent));
          }

        });

        this.map.getSource('markers').setData({
          type: 'FeatureCollection',
          features: features
        });
      }
    },
    toggleActive(value) {
      this.showActive = value;
    },
    showTag(id) {
      // this.clearSidebar();
      this.selected_tag = this.tags.find(tag => parseInt(tag.tid) === parseInt(id));
    },
    showArea() {

      if(this.areaOnly) {
        window.location.href = this.selected_marker.link;
      } else {
        this.selected_area = this.selected_marker;
      }

    },
    showProgram() {
      // this.clearSidebar();
      this.selected_program = this.selected_marker;
    },
    toggleFilter(tid) {
      this.filters.find(filter => filter.tid === tid).checked = !this.filters.find(filter => filter.tid === tid).checked;
    },
    clearSidebar() {
      this.titleVisible=false;
      this.selected_marker=null;
      this.selected_program=null;
      this.selected_area=null;
      this.selected_tag=null;
      this.showInfo=false;
    },
    reset() {
      this.clearSidebar();
      this.closeFilters();

      if(this.areaOnly) {
        this.map.fitBounds(bbox(this.geojson), {
          padding: 100
        });
      } else {
        this.map.fitBounds(bbox(this.bounds));
        window.setTimeout(() => {
          this.titleVisible = true;
        }, 1000);
      }


    },
    initMap() {

      const bounds = [
        [0.9063308434060957, 50.601914012794936], // Southwest coordinates
        [ 7.991906626807122, 54.66338503001114] // Northeast coordinates
      ];

      const map =
        new mapboxgl.Map({
          container: 'ark_35_map', // container id
          style: 'mapbox://styles/arkrewilding/cm4ldqsh3000101qt9eae59b9', // style URL
          preserveDrawingBuffer: true,
          minZoom: 5, // note the camel-case
          maxZoom: 14,
          maxBounds: bounds // Set the map's geographical boundaries.
        });


      if(!this.areaOnly) {
        map.fitBounds(bbox(this.bounds));
      }




      // disable map rotation using right click + drag
      map.dragRotate.disable();

      if(this.areaOnly) {
        map.scrollZoom.disable();
      }


      const isTouchEvent = e => e.originalEvent && "touches" in e.originalEvent;
      const isTwoFingerTouch = e => e.originalEvent.touches.length >= 2;

      map.on("dragstart", event => {
        if (isTouchEvent(event) && !isTwoFingerTouch(event)) {
          map.dragPan.disable();
        }
      });

      // Drag events not emited after dragPan disabled, so I use touch event here
      map.on("touchstart", event => {
        if (isTouchEvent(event) && isTwoFingerTouch(event)) {
          map.dragPan.enable();
        }
      });

      let component = this;


      if(!this.areaOnly) {


        function forwardGeocoder(query) {
          const matchingFeatures = [];
          for (const feature of component.geojson.features) {

            // Handle queries with different capitalization
            // than the source data by calling toLowerCase().
            if (
              feature.properties.name
                .toLowerCase()
                .includes(query.toLowerCase())
            ) {
              feature['place_name'] = feature.properties.name.replace('&#039;', "'");
              feature['geometry'] = feature.geometry;
              feature['place_type'] = ['park'];
              matchingFeatures.push(feature);
            }
          }
          return matchingFeatures;
        }

        // Add the control to the map.
        map.addControl(
          new MapboxGeocoder({
            types: 'place,locality',
            placeholder: 'zoeken',
            accessToken: mapboxgl.accessToken,
            mapboxgl: mapboxgl,
            marker: false,
            countries: 'nl',
            localGeocoder: forwardGeocoder,
          })
        );
      }


      let homediv = document.createElement('div');
      homediv.innerHTML = '<div class="mapboxgl-ctrl-info" type="button" aria-label="Show info"><span class="mapboxgl-ctrl-icon" aria-hidden="true" title="Show info"><svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
        '<path d="M40 20C40 31.0457 31.0457 40 20 40C8.95431 40 0 31.0457 0 20C0 8.95431 8.95431 0 20 0C31.0457 0 40 8.95431 40 20Z" fill="white"/>\n' +
        '<path fill-rule="evenodd" clip-rule="evenodd" d="M13.0718 16.4567C13.4391 16.4567 13.7368 16.7544 13.7368 17.1217L13.7368 27.1217C13.7368 27.4889 13.4391 27.7867 13.0718 27.7867C12.7045 27.7867 12.4068 27.4889 12.4068 27.1217L12.4068 17.1217C12.4068 16.7544 12.7045 16.4567 13.0718 16.4567Z" fill="#0A5256"/>\n' +
        '<path fill-rule="evenodd" clip-rule="evenodd" d="M21.7368 27.1217C21.7368 27.489 21.4391 27.7867 21.0718 27.7867L13.0718 27.7867C12.7045 27.7867 12.4068 27.489 12.4068 27.1217C12.4068 26.7545 12.7045 26.4567 13.0718 26.4567L21.0718 26.4567C21.4391 26.4567 21.7368 26.7545 21.7368 27.1217Z" fill="#0A5256"/>\n' +
        '<path fill-rule="evenodd" clip-rule="evenodd" d="M12.4958 17.4542C12.3122 17.1361 12.4212 16.7294 12.7392 16.5458L19.6674 12.5458C19.9855 12.3622 20.3922 12.4711 20.5758 12.7892C20.7595 13.1073 20.6505 13.514 20.3324 13.6976L13.4042 17.6976C13.0862 17.8812 12.6795 17.7723 12.4958 17.4542Z" fill="#0A5256"/>\n' +
        '<path fill-rule="evenodd" clip-rule="evenodd" d="M19.4241 12.7892C19.6077 12.4711 20.0144 12.3621 20.3325 12.5458L27.2607 16.5458C27.5788 16.7294 27.6877 17.1361 27.5041 17.4542C27.3205 17.7722 26.9138 17.8812 26.5957 17.6976L19.6675 13.6976C19.3494 13.5139 19.2405 13.1072 19.4241 12.7892Z" fill="#0A5256"/>\n' +
        '<path fill-rule="evenodd" clip-rule="evenodd" d="M26.9283 16.4567C27.2955 16.4567 27.5933 16.7544 27.5933 17.1217L27.5933 27.1217C27.5933 27.4889 27.2955 27.7867 26.9283 27.7867C26.561 27.7867 26.2633 27.4889 26.2633 27.1217L26.2633 17.1217C26.2633 16.7544 26.561 16.4567 26.9283 16.4567Z" fill="#0A5256"/>\n' +
        '<path fill-rule="evenodd" clip-rule="evenodd" d="M20 38.6667C30.3093 38.6667 38.6667 30.3093 38.6667 20C38.6667 9.69069 30.3093 1.33333 20 1.33333C9.69069 1.33333 1.33333 9.69069 1.33333 20C1.33333 30.3093 9.69069 38.6667 20 38.6667ZM20 40C31.0457 40 40 31.0457 40 20C40 8.95431 31.0457 0 20 0C8.95431 0 0 8.95431 0 20C0 31.0457 8.95431 40 20 40Z" fill="#0A5256"/>\n' +
        '</svg></span></div>';
      homediv.addEventListener('click', () =>  this.reset());

      map.addControl(new InfoControl(homediv), 'bottom-right');

      if(!this.areaOnly){

        let infodiv = document.createElement('div');
        infodiv.innerHTML = '<div class="mapboxgl-ctrl-info" type="button" aria-label="Show info"><span class="mapboxgl-ctrl-icon" aria-hidden="true" title="Show info"><svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
          '<path d="M40 20C40 31.0457 31.0457 40 20 40C8.95431 40 0 31.0457 0 20C0 8.95431 8.95431 0 20 0C31.0457 0 40 8.95431 40 20Z" fill="white"/>\n' +
          '<path fill-rule="evenodd" clip-rule="evenodd" d="M20 38.6667C30.3093 38.6667 38.6667 30.3093 38.6667 20C38.6667 9.69069 30.3093 1.33333 20 1.33333C9.69069 1.33333 1.33333 9.69069 1.33333 20C1.33333 30.3093 9.69069 38.6667 20 38.6667ZM20 40C31.0457 40 40 31.0457 40 20C40 8.95431 31.0457 0 20 0C8.95431 0 0 8.95431 0 20C0 31.0457 8.95431 40 20 40Z" fill="#0A5256"/>\n' +
          '<path fill-rule="evenodd" clip-rule="evenodd" d="M19.9997 16.75C21.8406 16.75 23.333 15.2576 23.333 13.4167C23.333 11.5757 21.8406 10.0833 19.9997 10.0833C18.1587 10.0833 16.6663 11.5757 16.6663 13.4167C16.6663 15.2576 18.1587 16.75 19.9997 16.75ZM19.9997 18.0833C22.577 18.0833 24.6663 15.994 24.6663 13.4167C24.6663 10.8393 22.577 8.75 19.9997 8.75C17.4223 8.75 15.333 10.8393 15.333 13.4167C15.333 15.994 17.4223 18.0833 19.9997 18.0833Z" fill="#0A5256"/>\n' +
          '<path fill-rule="evenodd" clip-rule="evenodd" d="M19.9997 31.2499C19.6315 31.2499 19.333 31.0767 19.333 30.863L19.333 20.8035C19.333 20.5898 19.6315 20.4166 19.9997 20.4166C20.3679 20.4166 20.6663 20.5898 20.6663 20.8035L20.6663 30.863C20.6663 31.0767 20.3679 31.2499 19.9997 31.2499Z" fill="#0A5256"/>\n' +
          '</svg></span></div>';
        infodiv.addEventListener('click', () => this.toggleInfo());

        map.addControl(new InfoControl(infodiv), 'bottom-right');
      }




      let mindiv = document.createElement('div');
      mindiv.innerHTML = '<div class="mapboxgl-ctrl-info" type="button" aria-label="Show info"><span class="mapboxgl-ctrl-icon" aria-hidden="true" title="Show info"><svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
        '<path d="M40 20C40 31.0457 31.0457 40 20 40C8.95431 40 0 31.0457 0 20C0 8.95431 8.95431 0 20 0C31.0457 0 40 8.95431 40 20Z" fill="white"/>\n' +
        '<path fill-rule="evenodd" clip-rule="evenodd" d="M20 38.6667C30.3093 38.6667 38.6667 30.3093 38.6667 20C38.6667 9.69069 30.3093 1.33333 20 1.33333C9.69069 1.33333 1.33333 9.69069 1.33333 20C1.33333 30.3093 9.69069 38.6667 20 38.6667ZM20 40C31.0457 40 40 31.0457 40 20C40 8.95431 31.0457 0 20 0C8.95431 0 0 8.95431 0 20C0 31.0457 8.95431 40 20 40Z" fill="#0A5256"/>\n' +
        '<path fill-rule="evenodd" clip-rule="evenodd" d="M29.3334 20C29.3334 20.3681 29.0349 20.6666 28.6667 20.6666L11.3334 20.6666C10.9652 20.6666 10.6667 20.3681 10.6667 20C10.6667 19.6318 10.9652 19.3333 11.3334 19.3333L28.6667 19.3333C29.0349 19.3333 29.3334 19.6318 29.3334 20Z" fill="#0A5256"/>\n' +
        '<path fill-rule="evenodd" clip-rule="evenodd" d="M29.3334 20C29.3334 20.3681 29.0349 20.6666 28.6667 20.6666L11.3334 20.6666C10.9652 20.6666 10.6667 20.3681 10.6667 20C10.6667 19.6318 10.9652 19.3333 11.3334 19.3333L28.6667 19.3333C29.0349 19.3333 29.3334 19.6318 29.3334 20Z" fill="#0A5256"/>\n' +
        '</svg></span></div>';
      mindiv.addEventListener('click', () =>  this.zoomOut());

      map.addControl(new InfoControl(mindiv), 'bottom-right');

      let plusdiv = document.createElement('div');
      plusdiv.innerHTML = '<div class="mapboxgl-ctrl-info" type="button" aria-label="Show info"><span class="mapboxgl-ctrl-icon" aria-hidden="true" title="Show info"><svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
        '<path d="M40 20C40 31.0457 31.0457 40 20 40C8.95431 40 0 31.0457 0 20C0 8.95431 8.95431 0 20 0C31.0457 0 40 8.95431 40 20Z" fill="white"/>\n' +
        '<path fill-rule="evenodd" clip-rule="evenodd" d="M20 38.6667C30.3093 38.6667 38.6667 30.3093 38.6667 20C38.6667 9.69069 30.3093 1.33333 20 1.33333C9.69069 1.33333 1.33333 9.69069 1.33333 20C1.33333 30.3093 9.69069 38.6667 20 38.6667ZM20 40C31.0457 40 40 31.0457 40 20C40 8.95431 31.0457 0 20 0C8.95431 0 0 8.95431 0 20C0 31.0457 8.95431 40 20 40Z" fill="#0A5256"/>\n' +
        '<path fill-rule="evenodd" clip-rule="evenodd" d="M29.3334 20C29.3334 20.3681 29.0349 20.6666 28.6667 20.6666L11.3334 20.6666C10.9652 20.6666 10.6667 20.3681 10.6667 20C10.6667 19.6318 10.9652 19.3333 11.3334 19.3333L28.6667 19.3333C29.0349 19.3333 29.3334 19.6318 29.3334 20Z" fill="black"/>\n' +
        '<path fill-rule="evenodd" clip-rule="evenodd" d="M20 29.3334C19.6319 29.3334 19.3334 29.0349 19.3334 28.6667L19.3334 11.3334C19.3334 10.9652 19.6319 10.6667 20 10.6667C20.3682 10.6667 20.6667 10.9652 20.6667 11.3334L20.6667 28.6667C20.6667 29.0349 20.3682 29.3334 20 29.3334Z" fill="black"/>\n' +
        '</svg></span></div>';
      plusdiv.addEventListener('click', () =>  this.zoomIn());

      map.addControl(new InfoControl(plusdiv), 'bottom-right');


      if(!this.areaOnly) {

        let filterdiv = document.createElement('div');
        filterdiv.innerHTML = '<div class="mapboxgl-ctrl-info" type="button" aria-label="Show info"><span class="mapboxgl-ctrl-icon" aria-hidden="true" title="Show info">' +
          '<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">' +
          '<path d="M40 20C40 31.0457 31.0457 40 20 40C8.95431 40 0 31.0457 0 20C0 8.95431 8.95431 0 20 0C31.0457 0 40 8.95431 40 20Z" fill="#0A5256"/>' +
          '<path fill-rule="evenodd" clip-rule="evenodd" d="M20 38.6667C30.3093 38.6667 38.6667 30.3093 38.6667 20C38.6667 9.69069 30.3093 1.33333 20 1.33333C9.69069 1.33333 1.33333 9.69069 1.33333 20C1.33333 30.3093 9.69069 38.6667 20 38.6667ZM20 40C31.0457 40 40 31.0457 40 20C40 8.95431 31.0457 0 20 0C8.95431 0 0 8.95431 0 20C0 31.0457 8.95431 40 20 40Z" fill="#0A5256"/>' +
          '<path fill-rule="evenodd" clip-rule="evenodd" d="M34 15.3333C34 15.7015 33.7015 16 33.3333 16L6.66667 16C6.29848 16 6 15.7015 6 15.3333C6 14.9651 6.29848 14.6667 6.66667 14.6667L33.3333 14.6667C33.7015 14.6667 34 14.9651 34 15.3333Z" fill="white"/>' +
          '<path d="M29.3333 15.3333C29.3333 17.9106 27.244 20 24.6667 20C22.0893 20 20 17.9106 20 15.3333C20 12.756 22.0893 10.6666 24.6667 10.6666C27.244 10.6666 29.3333 12.756 29.3333 15.3333Z" fill="#0A5256"/>' +
          '<path fill-rule="evenodd" clip-rule="evenodd" d="M24.6667 18.6666C26.5076 18.6666 28 17.1742 28 15.3333C28 13.4923 26.5076 12 24.6667 12C22.8257 12 21.3333 13.4923 21.3333 15.3333C21.3333 17.1742 22.8257 18.6666 24.6667 18.6666ZM24.6667 20C27.244 20 29.3333 17.9106 29.3333 15.3333C29.3333 12.756 27.244 10.6666 24.6667 10.6666C22.0893 10.6666 20 12.756 20 15.3333C20 17.9106 22.0893 20 24.6667 20Z" fill="white"/>' +
          '<path fill-rule="evenodd" clip-rule="evenodd" d="M6 24.6667C6 24.2985 6.29848 24 6.66667 24L33.3333 24C33.7015 24 34 24.2985 34 24.6667C34 25.0349 33.7015 25.3333 33.3333 25.3333L6.66667 25.3333C6.29848 25.3333 6 25.0349 6 24.6667Z" fill="white"/>' +
          '<path d="M10.6667 24.6667C10.6667 22.0894 12.756 20 15.3333 20C17.9107 20 20 22.0894 20 24.6667C20 27.244 17.9107 29.3334 15.3333 29.3334C12.756 29.3334 10.6667 27.244 10.6667 24.6667Z" fill="#0A5256"/>' +
          '<path fill-rule="evenodd" clip-rule="evenodd" d="M15.3333 21.3334C13.4924 21.3334 12 22.8258 12 24.6667C12 26.5077 13.4924 28 15.3333 28C17.1743 28 18.6667 26.5077 18.6667 24.6667C18.6667 22.8258 17.1743 21.3334 15.3333 21.3334ZM15.3333 20C12.756 20 10.6667 22.0894 10.6667 24.6667C10.6667 27.244 12.756 29.3334 15.3333 29.3334C17.9107 29.3334 20 27.244 20 24.6667C20 22.0894 17.9107 20 15.3333 20Z" fill="white"/>' +
          '</svg></span></div>';
        filterdiv.addEventListener('click', () => this.toggleFilters());

        map.addControl(new InfoControl(filterdiv), 'bottom-right');
      }


      map.on('load', () => {

        map.addSource('no_uk', {
          "url": "mapbox://arkrewilding.2lhi6w8d",
          "type": "vector"
        });

        map.addLayer({
          'id': 'no_uk_layer',
          'type': 'fill',
          'source': 'no_uk',
          'source-layer': 'map3-a3226s',
          'paint': {
            'fill-color': '#79bcec'
          }
        });




          map.loadImage(
            '/modules/custom/ark_map/icons/cluster.png',
            (error, image) =>  {
              if (error) {
                throw error;
              }
              map.addImage('custom-marker', image);
              this.loadData();


            });

      });

      map.on('movestart', () => {
        this.titleVisible = false;
      });
      map.on('zoomstart', () => {
        this.titleVisible = false;
      });



      this.map = map;

      const popup = new mapboxgl.Popup();

      this.popup = popup;

    },

    zoomIn() {
      this.map.easeTo({zoom: this.map.getZoom() + 1, duration: 1000})
    },
    zoomOut() {
      this.map.easeTo({zoom: this.map.getZoom() - 1, duration: 1000})
    },
    loadData() {

      let url = '/api/markers.geojson';

      if(this.node_id) {
        url = '/api/' + this.node_id + '/markers.geojson';
      }


      axios.get(url)
        .then(response => {
          this.geojson = response.data;
          this.addMarkers();
          this.checkQueryParams();
        })
        .catch(function (error) {
          // handle error
          console.log(error);
        })
        .finally(function () {
          // always executed

        });
    },
    checkQueryParams() {

      let queryParams = new URLSearchParams(window.location.search);
      if(queryParams.has('marker')  ) {
        this.showPopupByMarkerID(queryParams.get('marker'));
      } else {
        if(this.areaOnly) {
          this.map.fitBounds(bbox(this.geojson), {padding: 100,animate: false});
        }

      }
    },
    showPopupByMarkerID(marker_id) {
      let feature = this.geojson.features.find(feature => feature.properties.nid == marker_id);
      if(typeof feature != 'undefined') {
        this.clearSidebar();
        this.map.easeTo({
          center: feature.geometry.coordinates,
          zoom: 10
        });
        this.showPopup(feature, false);
      }
    },
    addMarkers() {



      let map = this.map;




      map.addSource('markers', {
        type: 'geojson',
        // Use a URL for the value for the `data` property.
        data: this.geojson,
        'cluster': true,
        'clusterMaxZoom': 13, // Max zoom to cluster points on
        'clusterRadius': 60 // Radius of each cluster when clustering points (defaults to 50)
      });







      map.addLayer({
        id: 'clusters',
        type: 'symbol',
        source: 'markers',
        filter: ['has', 'point_count'],
        'layout': {
          'icon-image': 'custom-marker',
          'icon-size': 0.8,
          'icon-anchor':'center',
          'icon-allow-overlap': true,
          'text-field': '{point_count_abbreviated}',
          'text-font': ["Arial Unicode MS Bold"],
          'text-size': 16,
          'text-allow-overlap': true,
        },
        "paint": {
          'text-color': '#0A5256'
        }
      });



      // map.addLayer({
      //   'id': 'markers-layer',
      //   'type': 'symbol',
      //   'source': 'markers',
      //   'filter': ['!', ['has', 'point_count']],
      //   'layout': {
      //     'icon-image': 'version-5',
      //     'icon-size': 1,
      //     'icon-anchor':'center',
      //     'icon-allow-overlap': true,
      //   },
      // });

      map.on('click', () => this.clearSidebar());

      map.on('click', 'clusters', (e) => {
        const features = map.queryRenderedFeatures(e.point, {
          layers: ['clusters']
        });
        const clusterId = features[0].properties.cluster_id;
        map.getSource('markers').getClusterExpansionZoom(
          clusterId,
          (err, zoom) => {
            if (err) return;

            map.easeTo({
              center: features[0].geometry.coordinates,
              zoom: zoom
            });
          }
        );
      });

      map.on('click', 'markers-layer',(e) => {
        this.clearSidebar();
        this.showPopup(e.features[0])
      });
      // after the GeoJSON data is loaded, update markers on the screen on every frame
      map.on('render', () => {
        if (!map.isSourceLoaded('markers')) return;
        this.updateMarkers();
      });
    },
    showPopup(feature, push_state =true) {

      if(this.areaOnly) {
        document.getElementById("map_app").scrollIntoView({behavior: 'smooth'});
        // let  top = document.getElementById("map_app").scrollIntoView();
        // console.log(top);
        // window.scrollTo({ top: top, behavior: 'smooth'});
      }

      axios.get('/api/markers/' + feature.properties.nid + '.json')
        .then(response => {
          this.selected_marker = response.data[0];

          if(push_state) {
            let queryParams = new URLSearchParams(window.location.search);
            queryParams.set('marker', feature.properties.nid);
            history.pushState({'marker_id':feature.properties.nid}, null, "?"+queryParams.toString());
          }

        })
        .catch(function (error) {
          // handle error
          console.log(error);
        })
        .finally(function () {
          // always executed
        });




    },
    updateMarkers() {
      const newMarkers = {};
      const features = this.map.querySourceFeatures('markers');

      // for every cluster on the screen, create an HTML marker for it (if we didn't yet),
      // and add it to the map if it's not there already
      for (const feature of features) {
        const coords = feature.geometry.coordinates;
        const props = feature.properties;
        if (props.cluster) continue;
        const id = props.nid;

        let marker = this.markers[id];
        if (!marker) {

          let el;

          // if(this.areaOnly) {
          //   el = this.createDefaultMarker();
          // } else {
            el = this.createDonutChart(props);
          // }

          el.addEventListener('click', () => {
            this.clearSidebar();
            this.showPopup(feature)
          });
          marker = this.markers[id] = new mapboxgl.Marker({
            element: el,
            anchor:'bottom'
          }).setLngLat(coords);
        }
        newMarkers[id] = marker;

        if (!this.markersOnScreen[id]) marker.addTo(this.map);
      }
      // for every marker we've added previously, remove those that are no longer visible
      for (const id in this.markersOnScreen) {
        if (!newMarkers[id]) this.markersOnScreen[id].remove();
      }
      this.markersOnScreen = newMarkers;
    },
    createDefaultMarker() {

      const r = 18;
      const r0 = Math.round(r * 0.4);
      const w = r * 2;


      let html = `<div>
                <svg width="50" height="60" viewBox="0 0 50 60" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M24.9736 0C11.6317 0 0.814697 10.817 0.814697 24.1589C0.814697 42.7662 24.9736 60 24.9736 60C24.9736 60 49.1325 42.7694 49.1325 24.1589C49.1325 10.817 38.3155 0 24.9736 0Z" fill="white"/>`;

        html += this.donutSegment(
          0,
          1,
          r,
          r0,
          '#B7245c',
          false
        );

      html += `<circle  class="popup-transform" cx="${r}" cy="${r}" r="${r0}" fill="white" />

                </svg>
                </div>`;

      const el = document.createElement('div');
      el.innerHTML = html;
      return el.firstChild;
    },
    createDonutChart(props) {

      let terms = props.what.split(',');
      let parents = [];


      if(terms.length === 0 || (terms.length === 1 && terms[0].trim() === '')) {
        return this.createDefaultMarker();
      }


      terms.forEach((term) => {
        let parent = this.tags.find(tag => tag.tid == term.trim()).parent_target_id;
        if(parents.indexOf(parent) === -1) {
          parents.push(parent);
        }

      });



      const offsets = [];
      let total = 0;
      for (const parent of parents) {
        offsets.push(total);
        total += 1
      }


      const r = 18;
      const r0 = Math.round(r * 0.4);
      const w = r * 2;

      // let html = `<div>
      //           <svg width="${w}" height="${w}" viewbox="0 0 ${w} ${w}" text-anchor="middle" style="display: block">`;

      let html = `<div>
                <svg width="50" height="60" viewBox="0 0 50 60" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M24.9736 0C11.6317 0 0.814697 10.817 0.814697 24.1589C0.814697 42.7662 24.9736 60 24.9736 60C24.9736 60 49.1325 42.7694 49.1325 24.1589C49.1325 10.817 38.3155 0 24.9736 0Z" fill="white"/>`;

      for (let i = 0; i < parents.length; i++) {

        let color = this.filters.find(filter => filter.tid == parents[i]).color;
        html += this.donutSegment(
          offsets[i] / total,
          (offsets[i] + 1) / total,
          r,
          r0,
          color,
          parents.length > 1
        );
      }
      html += `<circle  class="popup-transform" cx="${r}" cy="${r}" r="${r0}" fill="white" />

                </svg>
                </div>`;

      const el = document.createElement('div');
      el.innerHTML = html;
      return el.firstChild;
    },
    donutSegment(start, end, r, r0, color, stroke) {
      console.log(start, end, color);


      if (end - start === 1) end -= 0.00001;
      const a0 = 2 * Math.PI * (start - 0.25);
      const a1 = 2 * Math.PI * (end - 0.25);
      const x0 = Math.cos(a0),
        y0 = Math.sin(a0);
      const x1 = Math.cos(a1),
        y1 = Math.sin(a1);
      const largeArc = end - start > 0.5 ? 1 : 0;

      stroke = stroke ? "white" : "none";

      // draw an SVG path
      return `<path class="popup-transform" d="M ${r + r0 * x0} ${r + r0 * y0} L ${r + r * x0} ${
        r + r * y0
      } A ${r} ${r} 0 ${largeArc} 1 ${r + r * x1} ${r + r * y1} L ${
        r + r0 * x1
      } ${r + r0 * y1} A ${r0} ${r0} 0 ${largeArc} 0 ${r + r0 * x0} ${
        r + r0 * y0
      }" fill="${color}" stroke="${stroke}"/>`;
    },
    toggleInfo(show=true) {
      this.showInfo = show;
    },
    closeInfo() {
      this.toggleInfo(false);
    },
    closeArea() {
      this.selected_area = null;
    },
    closeProgram() {
      this.selected_program = null;
    },
    closeFilters() {
      if(this.$refs.filters) {
        this.$refs.filters.showSidebar = false;
      }
        window.setTimeout(() => {
          this.showFilters = false;
        }, 300);
    },
    toggleFilters() {
      if(this.showFilters) {
        this.closeFilters();
      } else {
        this.titleVisible = false;
        this.showFilters = !this.showFilters;
      }
    },
    loadTags() {
      axios.get('/api/tags.json')
        .then(response => {
          this.tags = response.data;
          this.parent_tags = response.data.filter(tag => tag.parent_target_id === '' && tag.vid == 'wat_doet_ark');
        })
        .catch(function (error) {
          // handle error
          console.log(error);
        })
        .finally(function () {
          // always executed
        });
    },


  },
  mounted() {

    let queryParams = new URLSearchParams(window.location.search);
    if(!queryParams.has('marker')) {
      history.replaceState({'initial' : true}, "", document.location.href);
    }


    this.initMap();
    this.loadTags();

    window.addEventListener("popstate", (event) => {
      if (event.state.marker_id) {
        this.showPopupByMarkerID(event.state.marker_id);
      } else if(event.state.initial) {
        this.clearSidebar();
      }
    });

  }
}
</script>



